import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import LearningContentInnerWrapper from './LearningContentInnerWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BOTTOM_SPACING = '1000';
export const LearningContentPageLayout = ({
  header,
  navigation,
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(LearningContentInnerWrapper, {
    children: /*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: navigation || isMobile ? undefined : BOTTOM_SPACING,
      children: [header, navigation ? /*#__PURE__*/_jsxs(Flex, {
        borderBlockEndStyle: !isMobile ? 'solid' : undefined,
        borderColor: "border-core-subtle",
        borderEndEndRadius: "400",
        borderEndStartRadius: "400",
        borderInlineStyle: !isMobile ? 'solid' : undefined,
        borderWidth: !isMobile ? '100' : undefined,
        flexDirection: isMobile ? 'column-reverse' : 'row',
        children: [navigation, /*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          marginBlockEnd: BOTTOM_SPACING,
          overflow: "hidden",
          children: children
        })]
      }) : children]
    })
  });
};
export default LearningContentPageLayout;